import { Component, OnInit, Inject } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material';

@Component({
  selector: 'app-terms-privacy',
  templateUrl: './terms-privacy.component.html',
  styleUrls: ['./terms-privacy.component.scss']
})
export class TermsPrivacyComponent implements OnInit {
  _terms;
  _privacy$;
  constructor(
    private _bottomSheetRef: MatBottomSheetRef<TermsPrivacyComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public matData: any
  ) {}

  ngOnInit() {
    this._terms = this.matData[0];
  }

  _cancel() {
    this._bottomSheetRef.dismiss();
    event.preventDefault();
  }
}
